"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
var _utils = require("../utils");
var _countup = _interopRequireDefault(require("countup.js"));
var _use = (0, _utils.use)('countup'),
  sfc = _use[0];
var _default2 = sfc({
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      // eslint-disable-next-line no-underscore-dangle
      _this._countup = new _countup.default(_this.$el, _this.startVal, _this.endVal, _this.decimals, _this.duration, _this.options);
      if (_this.start) {
        // eslint-disable-next-line no-underscore-dangle
        _this._countup.start();
      }
    });
  },
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    start: {
      type: Boolean,
      default: true
    },
    startVal: {
      type: Number,
      default: 0
    },
    endVal: {
      type: Number,
      required: true
    },
    // number of decimal places in number
    decimals: {
      type: Number,
      default: 0
    },
    // duration in seconds
    duration: {
      type: Number,
      default: 2
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  render: function render(h) {
    return h(this.tag, {
      class: 'z-countup'
    }, [this.startVal]);
  },
  watch: {
    start: function start(val) {
      if (val) {
        // eslint-disable-next-line no-underscore-dangle
        this._countup.start();
      }
    },
    endVal: function endVal(val) {
      // eslint-disable-next-line no-underscore-dangle
      this._countup.update(val);
    }
  }
});
exports.default = _default2;